const { createSelector } = require('reselect')

const selectProduct = state => state['marketplace.marketBusinessCatalogue'].product

const product = () => createSelector(
  [selectProduct],
  prod => prod.data,
)

const productError = () => createSelector(
  [selectProduct],
  prod => prod.error,
)

const productLoading = () => createSelector(
  [selectProduct],
  prod => prod.loading,
)

const selectList = state => state['marketplace.marketBusinessCatalogue'].list

const list = () => createSelector(
  [selectList],
  products => products.data,
)

const listError = () => createSelector(
  [selectList],
  products => products.error,
)

const listLoading = () => createSelector(
  [selectList],
  products => products.loading,
)


module.exports = {
  product,
  productError,
  productLoading,

  list,
  listError,
  listLoading
}
